import React, { useState } from 'react';
import Button from "@mui/material/Button";


interface OTPInputProps {
    length?: number;
    verifyOTP: (otp: string) => void;
}

const OTPInput: React.FC<OTPInputProps> = ({ length = 6, verifyOTP}) => {
    const [otp, setOTP] = useState<string[]>(new Array(length).fill(""));
    // const phoneNo = useSelector((state:RootState) => state.auth.phone_no)
    const handleChange = (element: HTMLInputElement, index: number) => {
        if (isNaN(Number(element.value))) return;

        const newOTP = [...otp];
        newOTP[index] = element.value;
        setOTP(newOTP);
        // onChangeOTP(newOTP.join(""));

        // Focus on the next input if the user has entered a digit
        if (element.nextElementSibling) {
            (element.nextElementSibling as HTMLInputElement).focus();
        }
    };
    const handleVerifyOTP = () => {
        verifyOTP(otp.join(""))
    }
    return (
        <div style={{alignItems: "center", textAlign:"center", marginTop:"80px", marginBottom:"80px"}}>
            {otp.map((data, index) => (
                <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                    style={{ width: "30px", marginRight: "5px", textAlign: "center" }}
                />
            ))}
            <br/>
            <Button color={"secondary"} onClick={handleVerifyOTP}>Verify OTP</Button>
        </div>
    );
};

export default OTPInput;
